import { Dispatch } from "react";

import api from "../api";
import { AdvertiserType } from "../types/advertiserTypes";
import { mapAdGroupTemplateToAdGroupToCreate } from "../types/campaignTypes";
import {
  setAdGroupToCreate,
  setCampaignBasicDetails,
  setCampaignCookies,
  setCampaignLandingPage,
  setCampaignSteps,
  setCampaignTemplate,
  setCampaignTemplateName,
  setCampaignToCreateSelectedAdvertiser,
  setFoundCompanyInfo,
  setFoundEmailsInfo,
  setSelectedAdGroupTemplate,
  setSelectedDomainLists,
  setSelectedDomainListsIds,
  setSelectedGeoTargetOptions,
  setSelectedSegmentIds,
  setSelectedZipCodes,
} from "../redux/reducers/campaignToCreate";

export const initializeStateWithTemplateData = async (
  template: any,
  dispatch: Dispatch<any>,
  advertisers: AdvertiserType[],
) => {
  dispatch(setCampaignSteps(template.templateSteps));
  dispatch(
    setCampaignBasicDetails({
      agencyId: template.agencyId,
      createdBy: template.createdBy,
      name: template.name,
      description: template.description,
      startDate: template.startDate,
      endDate: template.endDate,
      estimatedBudget: template.estimatedBudget,
      dailyBudget: template.dailyBudget,
      maxBid: template.maxBid,
      showInHubspot: template.showInHubspot,
      maxCompanies: template.maxCompanies,
      isVideoCampaign: template.isVideoCampaign,
    }),
  );
  const selectedAdvertiser = advertisers.find(
    (advertiser) => advertiser.brandgenAdvertiserId === template.selectedAdvertiser,
  );

  if (selectedAdvertiser) {
    dispatch(setCampaignToCreateSelectedAdvertiser(selectedAdvertiser));
  }
  dispatch(setFoundCompanyInfo(template.foundCompanyInfo));
  dispatch(setFoundEmailsInfo(template.foundEmailsInfo));
  dispatch(setSelectedGeoTargetOptions(template.selectedGeoTargetOptions));
  dispatch(setCampaignCookies(template.campaignCookieSets));
  dispatch(setCampaignLandingPage(template.landingPage));
  dispatch(setAdGroupToCreate(template.adGroupToCreate));
  dispatch(setSelectedAdGroupTemplate(template.selectedAdGroupTemplate));
  dispatch(setSelectedZipCodes(template.selectedZipCodes));
  dispatch(setSelectedSegmentIds(template.selectedSegmentIds));
  dispatch(setSelectedDomainListsIds(template.selectedDomainListsIds));
  dispatch(setCampaignTemplateName(template.templateName));
  dispatch(setCampaignTemplate(template));

  if (template.selectedAdGroupTemplate) {
    try {
      const adGroupTemplate = await api.getAdGroupById(template.selectedAdGroupTemplate);
      const adGroupToCreate = mapAdGroupTemplateToAdGroupToCreate(adGroupTemplate);
      dispatch(setAdGroupToCreate(adGroupToCreate));
    } catch (error) {
      console.error("Failed to fetch ad group from selected template:", error);
    }
  }

  if (template.id) {
    try {
      const roleTitles = await api.getRoleTitlesForTemplate(template.id);
      dispatch(setCampaignCookies(roleTitles));
    } catch (error) {
      console.error("Failed to fetch ad group from selected template:", error);
    }
  }
};
